<template src="./surveyInfoPage.html"></template>

<script>
    import surveysEndpoints from '../surveys.endpoints';
    import dataTableMixin from '../../../js/dataTableMixin.js';
    import Vue from 'vue';

    export default {
        name: 'survey-info-page',
        mixins: [dataTableMixin],
        data() {
            return {
                surveyDetails: {},
                surveyTeams: [],
                dto: {
                    SurveyID: -1,
                    TeamType: {},
                    SearchText: '',
                    IncludeInactive: false,
                    PageNumber: 1,
                    PageRows: 100,
                    SortByColumn: 'Email',
                    SortDirection: 'asc'
                },
                previewOptions: [],
                tabIndex: 0,
				teamUsersTableItems: {},
                teamUsersTableColumns: [],
                teamUsersTableSortBy: {
                    columns: [
                        { field: 'Email', direction: 'Ascending' },
                    ]
                },
                institutionName: '',
                tabAnimation: { 
                    previous: { 
                        effect: 'None', 
                    },
                    next: { 
                        effect: 'None', 
                    } 
                },
                showTransformationTooltip: false,
                showStudentSuccessTooltip: false,
                teamUserTypeNumberOfRecords: 0,
                deliveryStatusTemplate: () => {
                    return {
                        template: Vue.component('deliveryStatusTemplate', {
                            template: `<ejs-tooltip
                                            v-if="data.DeliveryStatuses.length > 0"
                                            :content="tooltipContent">
                                            <i class="fa fa-circle fa-2x" :class="data.DeliveryStatusIsBad ? 'app-delivery-indicator-bad' : 'app-delivery-indicator-good'"></i>
                                        </ejs-tooltip>`,
                            data() {
                                return {}
                            },
                            computed: {
                                tooltipContent() {
                                    if (this.data.DeliveryStatuses.length == 0) {
                                        return;
                                    }

                                    let html = `
                                            <table class="delivery-status-table">
                                                <th>Type</th>
                                                <th>Sent At</th>
                                                <th>Status</th>
                                                <th>Reason</th>
                                        `;

                                    this.data.DeliveryStatuses.forEach((ds) => {
                                        let dsHtml = `
                                            <tr>
                                                <td>${ds.MessageType}</td>
                                                <td>${ds.MessageSentAtDateTimeF}</td>
                                                <td>${ds.DeliveryStatus}</td>
                                                <td>${ds.DeliveryStatusReason}</td>
                                            </tr>
                                        `;

                                        html += dsHtml;
                                    });

                                    html += `</table>`;

                                    return html;
                                }
                            },
                        })
                    }
                },
                deactivateTemplate: () => {
                    return {
                        template: Vue.component('deactivateTemplate', {
                            template: `<ejs-button
                                            class="app-btn-md"
                                            :disabled="data.StatusType !== 'Active'"
                                            :isPrimary="true">
                                            Deactivate
                                        </ejs-button>`,
                            data() {
                                return {}
                            },
                        })
                    }
                },
            }
        },
        computed: {
            teamUsersTableIconTemplates() {
                return {
                    DeliveryStatus: this.deliveryStatusTemplate,
                    Deactivate: this.deactivateTemplate
                }
            },
        },
        methods: {
            getNumRecordsForType(type) {
                if (this.teamUserTypeNumberOfRecords.length === 0) {
                    return 0;
                }

                let recordsForType = this.teamUserTypeNumberOfRecords.find((record) => record.TeamType === type);

                if (recordsForType && recordsForType.NumberOfRecords) {
                    return recordsForType.NumberOfRecords;
                } else {
                    return 0;
                }

            },
            showTabCountIcon(type) {
                if (this.dto.SearchText === '') {
                    return false;
                }

                if (this.dto.TeamType.TeamType === type) {
                    return false;
                }

                if (this.getNumRecordsForType(type) === 0) {
                    return false;
                }

                return true;
            },
            manageReminders() {
                let modalData = {
                    surveyID: this.dto.SurveyID
                };

                surveysEndpoints.getScheduledReminders(this.surveyDetails.SurveyID)
                    .then((response) => {
                        modalData.dto = response;

                        DMUtils.openApplicationModal('manageRemindersModal', modalData);
                    })
            },
            previewSurvey(args) {
                DMUtils.setCookie('ita-token', DMUtils.getAuthToken(), '/', window.cookieDomain);

                let url = '';

                if (args.item.text === 'Transformation Team') {
                    url = this.surveyDetails.TransformationTeamLink;
                }

                if (args.item.text === 'Student Success Community') {
                    url = this.surveyDetails.StudentSuccessCommunityLink;
                }

                let link = document.createElement('a');
                link.href = url + '&isPreview=true';
                link.target = '_blank';
                app.appendChild(link);
                link.click();
            },
            copyTransformationTeamLink() {
                return navigator.clipboard.writeText(this.surveyDetails.TransformationTeamLink)
                    .then(() => {
                        this.showTransformationTooltip = true;
                        setTimeout(() => {
                            this.showTransformationTooltip = false;
                        }, 1000)
                    });
            },
            copyStudentSuccessCommunityLink() {
                return navigator.clipboard.writeText(this.surveyDetails.StudentSuccessCommunityLink)
                    .then(() => {
                        this.showStudentSuccessTooltip = true;
                        setTimeout(() => {
                            this.showStudentSuccessTooltip = false;
                        }, 1000)
                    });
            },
            onTabChange(args) {
                this.dto.IncludeInactive = false;
                this.teamUsersTableItems = [];
                this.dto.TeamType = this.surveyTeams[args.selectedIndex];
                this.getAll();
            },
            tabSelecting(args) {
                if (args.isSwiped) {
                    args.cancel = true;
                }
            },
            teamUsersTableRowOnClick(args) {
                if (args.cellIndex === 0) {
                    this.selectedRow = args;
                    this.deactivateUser();
                }
            },
            getAll() {
                surveysEndpoints.getAllSurveyTeamUsers(this.dto)
                	.then((response) => {
                        this.teamUsersTableItems = {
                            result: response.Rows,
                            count: response.NumberOfRecords,
                        }

                        this.teamUserTypeNumberOfRecords = response.TeamUserTypeNumberOfRecords;
                	});
			},
            importTeamUsers() {
                let modalData = {
                    team: this.dto.TeamType,
                    dto: {
                        SurveyID: this.surveyDetails.SurveyID,
                        TeamID: this.dto.TeamType.TeamID,
                        EmailAddressString: ''
                    },
                    callback: this.getAll,
                }

                DMUtils.openApplicationModal('teamUserImportModal', modalData);
            },
            create() {
                let modalData = {
                    team: this.dto.TeamType,
                    dto: {
                        SurveyID: this.surveyDetails.SurveyID,
                        TeamID: this.dto.TeamType.TeamID,
                        EmailAddress: ''
                    },
                    callback: this.getAll,
                }

                DMUtils.openApplicationModal('teamUserEditModal', modalData);
            },
            deactivateUser() {
                if (this.selectedRow.rowData.StatusType === 'Active') {
                    const title = 'Confirm';
                    const message = 'Are you sure you want to deactivate this user?';
    
                    DMUtils.confirmShow(message, title, this.deactivateConfirm, null, 'Yes', 'No');
                }
            },
            deactivateConfirm() {
                surveysEndpoints.deactivateUser(this.selectedRow.rowData.RespondentID)
                    .then(() => {
                        this.getAll();
                    })
            },
            routeToSurveyDashboard() {
                this.$router.push({name: 'surveys'});
            },
            setTableColumns() {
                this.teamUsersTableColumns = [
                    {
                        type: 'iconTemplate',
                        name: 'Deactivate',
                        label: '',
                        width: '120px',
                        allowSorting: false
                    },
                    {
                        key: 'DeliveryStatus',
                        label: 'Delivery Status',
                        type: 'iconTemplate',
                        name: 'DeliveryStatus',
                        width: '145px',
                        textAlign: 'Center',
                        allowSorting: true
                    },
                    {
                        key: 'StatusType',
                        label: 'Invite Status',
                        width: '100px',
                        allowSorting: true
                    },
                    {
                        key: 'InvitationSendDateTimeF',
                        label: 'Scheduled Send Date/Time',
                        width: '225px',
                        allowSorting: true
                    },
                    {
                        key: 'Email',
                        label: 'Email',
                        width: '300px',
                        allowSorting: true
                    },
                    {
                        key: 'TeamUserType',
                        label: 'Type',
                        width: '100px',
                        allowSorting: true
                    },
                ];  
            }
        },
        created() {
            this.institutionName = this.$route.query.institution;

            surveysEndpoints.getAllTeams(this.$route.query.surveyID)
                .then((response) => {
                    this.surveyTeams = response;
                    this.dto.TeamType = this.surveyTeams[0];
                    this.setTableColumns();
                    return surveysEndpoints.getDetailsByID(this.$route.query.surveyID)    
                })
                .then((response) => {
                    this.dto.SurveyID = response.SurveyID;
                    this.surveyDetails = response;

                    this.previewOptions = this.surveyTeams.map((team) => {
                        return { text: team.Name }
                    });

                    this.getAll();        
                });        
        },
    }
</script>
